<template>
	<div class="basis-page-cls">
        <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
                <div class="btns">
                    <el-button @click.stop="handleCreate" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增问卷</el-button>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNumber"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList" />
            </div>
        </section>

		<el-drawer 
            :title="dialog_status == 'create' ? '新增问卷' : '修改问卷'" 
            :visible.sync="dialog_visible_touch_in"
            :wrapperClosable="false"
			size="600px"
            direction="rtl">
            <el-form labelPosition="right" autoComplete="on" labelWidth="120px" :model="questionnaire_form" ref="questionnaire_form">
                <el-form-item prop="paperName" label="问卷名称：" :rules="[{required: true, trigger: 'blur', message: '请输入问卷名称'}]">
                    <el-input v-model="questionnaire_form.paperName" placeholder="请输入问卷名称" maxlength="100" show-word-limit style="width:450px;" clearable></el-input>
                </el-form-item>
                <el-form-item prop="subBrandIdentify" label="子品牌：" :rules="[{required: true, trigger: 'change', message: '请选择子品牌'}]">
                    <el-select v-model="questionnaire_form.subBrandIdentify" placeholder="请选择子品牌" style="width:450px;">
                        <el-option v-for="item in subBrandList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item prop="paperShowType" label="显示方式：" :rules="[{required: true, trigger: 'blur', message: '请选择显示方式'}]">
                    <el-radio v-model="questionnaire_form.paperShowType" :label="2">单页显示</el-radio>
					<el-radio v-model="questionnaire_form.paperShowType" :label="1">分题显示</el-radio>
                </el-form-item>
				<el-form-item prop="remark" label="说明：">
                    <el-input v-model="questionnaire_form.remark" type="textarea" :rows="3" maxlength="300" show-word-limit placeholder="请输入说明" style="width:450px;" clearable></el-input>
                </el-form-item>
				<el-form-item prop="paperStatus" label="状态：" :rules="[{required: true, trigger: 'blur', message: '请选择状态'}]">
                    <el-switch v-model="questionnaire_form.paperStatus" active-value="0" inactive-value="2" active-color="#13ce66" active-text="启用" inactive-text="未启用"></el-switch>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item style="float: right;padding-right: 30px;">
                    <el-button @click="dialog_visible_touch_in = false" size="small">取 消</el-button>
                    <el-button @click.stop="create" :loading="loading" type="primary" size="small">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin } from "utils/mixins";
export default {
	name: 'CustomerPageIndex',
	mixins: [EnumMixin],
	computed: {
        ...mapGetters([
			'userInfo',  
			'subBrandList'
		])
    },
	data() {
		return {
            column: [
				{
                    label: '序号',
                    width: 80,
                    render: (h, scope) => {
                        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
                    }
                },
				{ label: '问卷名称', prop: 'paperName' },
				{ label: '备注', prop: 'remark' },
				{
                    label: '问卷状态',
                    render: (h, scope) => {
                        return <el-tag type={scope.row.paperStatus == '0' ? 'success' : 'info'} size="small">{scope.row.paperStatus == '0' ? '已启用' : '未启用'}</el-tag>
                    }
                },
				{ label: '最近更新时间', prop: 'updated' },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 230,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-link onClick={() => this.handleDesign(scope.row)} underline={false} type="primary">设计问卷</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handleEdit(scope.row)} underline={false} type="primary">修改</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handleCopy(scope.row)} underline={false} type="primary">复制</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handleDelete(scope.row)} underline={false} type="danger" disabled={scope.row.paperStatus == '0'}>删除</el-link>
							</div>
						)
                    }
                }
            ],
			filterHeader: [
				{label: '子品牌', model: 'subBrandIdentify', type: 'select', default: '', list: []},
				{label: '问卷名称', model: 'paperName', type: 'input', default: '', placeholder: '请输入问卷名称'},
				{label: '问卷状态', model: 'paperStatus', type: 'select', default: '', list: [
					{id: '0', name: '已启用'},
					{id: '2', name: '未启用'}
				]},
			],
			listQuery: {
				pageSize: 10,
                pageNumber: 1,
				brandIdentify: '',
				subBrandIdentify: '',
				paperName: '',
				paperStatus: '',
				channelIdentify: '',
				paperId: '',
            },
			total: 0,
			list: [],
			loading: false,
			dialog_status: 'create',
			dialog_visible_touch_in: false,
			questionnaire_form: {
				brandIdentify: '',
				paperName: '',
				subBrandIdentify: '',
				paperShowType: 2,
				paperStatus: '0',
				remark: '',
				channelIdentify: ''
			}
		}
    },
	created() {
		this.listQuery.subBrandIdentify = this.userInfo.brandList && this.userInfo.brandList.length > 0 ? this.userInfo.brandList[0] : '';
		this.getList();
		this.filterHeader[0]['list'] = this.subBrandList;
	},
	methods: {
		getList() {
			this.listQuery.brandIdentify = this.userInfo.brandIdentify;
			this.$api.apiGetSurveyPaperList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
				this.total = parseInt(response.total);
			});
		},
		handleCopy(row){
				this.$confirm('确认复制该问卷, 是否继续?', '系统提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.copyBreathPaperItem({
					paperId: row.paperId
				}).then(response => {
					if(response.errcode != 0) return;
						this.$notify({
						title: "复制成功",
						type: "success"
					});
					this.getList()
				});
			}).catch(() => {});
		},
		handleCreate() {
			this.resetForm();
			this.dialog_status = 'create';
			this.dialog_visible_touch_in = true;
		},
		handleEdit(row) {
			this.resetForm();
			this.dialog_status = 'update';
			this.questionnaire_form = Object.assign(this.questionnaire_form, row);
			this.dialog_visible_touch_in = true;
		},
		handleDesign(row) {
			this.$router.push({path: `/breathe/questionnaire/design/${row.paperId}`});
		},
		handleDelete(row) {
			this.$confirm('删除后将无法恢复, 是否继续?', '系统提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.apiPostSurveyPaperDelete({
					brandIdentify: row.brandIdentify,
					paperId: row.paperId
				}).then(response => {
					if(response.errcode != 0) return;
					this.$notify({
						title: "删除成功",
						type: "success"
					});
					this.getList();
				});
			}).catch(() => {});
		},
		create() {
			this.$refs["questionnaire_form"].validate(valid => {
                if (valid) {
                    this.loading = true;
					this.questionnaire_form.brandIdentify = this.userInfo.brandIdentify;
                    this.$api.apiPostSurveyPaperCreateUpdate({surveyPaper: this.questionnaire_form}).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						};
                        this.$notify({
                            title: "提交成功",
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		resetForm() {
			this.questionnaire_form = {
				brandIdentify: '',
				paperName: '',
				subBrandIdentify: this.listQuery.subBrandIdentify,
				paperShowType: 2,
				paperStatus: '0',
				remark: '',
			}
			if (this.$refs["questionnaire_form"]) {
				this.$refs["questionnaire_form"].clearValidate();
			}
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList();
		}
    }
}
</script>